import React, { FC } from 'react';
import { Button } from 'antd';
import classNames from 'classnames';
import styles from './Annotation.module.scss';

type Props = {
  hideTree: boolean;
  hideStichedView: boolean;
  fullScreenMode: boolean;
  setHideTree: (value: boolean) => void;
  setHideStichedView: (value: boolean) => void;
};

const HiddenViews: FC<Props> = ({ hideTree, hideStichedView, fullScreenMode, setHideTree, setHideStichedView }) => {
  return (
    <div
      className={classNames({
        [styles.sideMenuButtons]: (hideTree || hideStichedView) && !fullScreenMode,
        [styles.hideSideMenuButtons]: (hideTree || hideStichedView) && fullScreenMode
      })}
    >
      {hideTree && (
        <Button className={styles.rotate} onClick={() => setHideTree(!hideTree)}>
          Tree View
        </Button>
      )}
      {hideStichedView && (
        <Button className={styles.rotate} onClick={() => setHideStichedView(!hideStichedView)}>
          Image View
        </Button>
      )}
    </div>
  );
};

export default HiddenViews;
